import { breadcrumb } from './breadcrumb';

export const call_tracking = {
  breadcrumb,

  number: {
    field: {
      number: 'Nomor',
      status: 'Status',
      created_at: 'Tambah tanggal',
      client_id: 'Nomor ID client',
      call_date: 'Tanggal Telpon ',
      caller_number: 'Nomor penelepon'
    },

    modal: {
      remove: {
        content: 'Saudara yakin berhenti memakai nomor {number} untuk call?'
      }
    }
  },

  integration: {
    connect: 'Koneksi',
    connect_desc: `Paste kata yang ada dibawah  shown halaman website, segera setelah   tag muncul <code>&lt;head&gt;</code>. Termasuk CLIENT_ID, spesifik unik visitor identitas.`,
    get_number: 'Dapatkan nomor',
    get_number_desc: 'Nomor telepone tersedia'
  },

  button: {
    create: 'Tambah nomor'
  }
};
